module.exports = __webpack_public_path__ + "img/point3_screen_flow2.7da974b6.png";